module.exports = __webpack_public_path__ + "d0458e46e878be62558ee616eb364644.svg";